const ISO_DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Converte data em texto para Date no fuso local.
 *
 * Datas de cadastro são gravadas como `AAAA-MM-DD` pelos inputs `type="date"`.
 * `new Date('2025-03-01')` interpretaria como UTC e voltaria um dia no Brasil,
 * então o formato só-data é montado a partir das partes.
 */
export function parseDateOnly(value: string | null | undefined): Date | null {
    if (!value) {
        return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    const match = ISO_DATE_ONLY.exec(trimmed);
    if (match) {
        const [, year, month, day] = match;
        const parsed = new Date(Number(year), Number(month) - 1, Number(day));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}
